import React, { useEffect, useState } from 'react';
import Avatar from "@mui/material/Avatar";
import { authUser } from "./fake-db";
import { Box, Chip, ListItem, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { useDispatch, useSelector } from 'react-redux';
import { getSingleMarketExecutive } from 'app/redux/actions/MarketExecutive';
import { SINGLE_MARKET_EXECUTIVE_RESET } from 'app/utils/constants/MarketExecutiveConstant';
import { formatDate } from 'app/pages/Component/Function/formatDate';
import ViewMET from 'app/pages/Profile/ViewMET';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';


function TextFeild({ label, value, sx }) {
    return <Typography sx={{ mt: 0, letterSpacing: 0.5, fontSize: "16px", ...sx }}>
        <Typography as="span" sx={{ fontWeight: 500, textTransform: "capitalize", fontSize: "16px" }}>{label}</Typography> :- {value}
    </Typography>
}

const AuthUserDropdown = () => {
    const navigate = useNavigate();
    const { theme } = useJumboTheme();
    const { setAuthToken } = useJumboAuth();
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const MarketExecu = useSelector((state) => state?.marketExecutiveReducer?.singleMarketExecutive?.data?.MarketExecutive)
    const metData = MarketExecu?.current_data;
    const metUser = JSON.parse(localStorage.getItem("metUserAndToken"))

    const onLogout = () => {
        // setAuthToken(null);
        localStorage.removeItem("metUserAndToken");
        dispatch({ type: SINGLE_MARKET_EXECUTIVE_RESET })
        navigate("/login");
        window.location.reload();
    };

    useEffect(() => {
        const isAuthenticated = metUser?.isAuthenticated === true && metUser?.token;
        if (isAuthenticated) {
            dispatch(getSingleMarketExecutive())
        }
    }, [dispatch])

    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={
                    // <Avatar
                    //     src={authUser.profile_pic}
                    //     sizes={"small"}
                    //     sx={{boxShadow: 25, cursor: 'pointer'}}
                    // />
                    // <Chip size='medium' avatar={
                    //     <Avatar sx={{bgcolor:"#7352C7"}}>{metUser?.metUser?.current_data?.contact_person_details?.first_name[0]}</Avatar>
                    // } label={metUser?.metUser?.current_data?.contact_person_details?.first_name} />
                    <Avatar sx={{ bgcolor: "#7352C7" }} >{metUser?.metUser?.current_data?.contact_person_details?.first_name[0]}</Avatar>
                    // <Box sx={{
                    //     bgcolor: "#7352C7",
                    //     width: "40px",
                    //     height: "40px",
                    //     borderRadius: "100%",
                    //     display: "flex",
                    //     justifyContent: "center",
                    //     alignItems: "center",
                    //     boxShadow: 25, cursor: 'pointer'
                    // }}>
                    //     <Typography variant='h2' sx={{ textTransform: "uppercase", m: 0, color: "white" }}>{metUser?.metUser?.current_data?.contact_person_details?.first_name[0]}</Typography>
                    // </Box>
                }
            >
                <Div sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    p: theme => theme.spacing(2.5),
                }}>
                    {/* <Avatar src={authUser.profile_pic} alt={authUser.name} sx={{width: 60, height: 60, mb: 2}}/> */}
                    <Box sx={{
                        bgcolor: "#7352C7",
                        width: "60px",
                        height: "60px",
                        borderRadius: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mb: 2
                    }}>
                        <Typography variant='h2' sx={{ textTransform: "uppercase", m: 0, color: "white" }}>{metUser?.metUser?.current_data?.contact_person_details?.first_name[0]}</Typography>
                    </Box>
                    <Typography variant={"h5"}>{`${metUser?.metUser?.current_data?.contact_person_details?.first_name} ${metUser?.metUser?.current_data?.contact_person_details?.last_name}`}</Typography>
                    <Typography variant={"body1"} color="text.secondary">{metUser?.metUser?.current_data?.contact_person_details?.primary_email_id}</Typography>
                </Div>
                <Divider />
                <nav>
                    <List disablePadding sx={{ pb: 1 }}>
                        <ListItem>
                            <ListItemText primary={
                                <Typography sx={{ fontSize: "18px" }}>Account Balance</Typography>
                            } sx={{ minHeight: 50, my: 0 }} secondary={
                                <ListItem sx={{color:"black"}}>
                                    <CurrencyRupeeIcon />
                                    <ListItemText primary={
                                        <Typography sx={{ fontSize: "18px" }}>{Number(Number(MarketExecu?.account_balance)?.toFixed(2))?.toLocaleString()}</Typography>
                                    } sx={{ my: 0 }} />
                                </ListItem>
                            } />
                        </ListItem>
                        <ListItemButton onClick={() => setOpen(true)}>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <PersonOutlineIcon />
                            </ListItemIcon>
                            <ListItemText primary="Profile" sx={{ my: 0 }} />
                        </ListItemButton>
                        <ListItemButton onClick={() => {
                            navigate("/dashboards/myProfile/edit")
                        }}>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <EditOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Edit Profile" sx={{ my: 0 }} />
                        </ListItemButton>
                        <ListItemButton onClick={() => {
                            navigate("/dashboards/myProfile/Nominee")
                        }}>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <Diversity2Icon />
                            </ListItemIcon>
                            <ListItemText primary="Manage Nominee" sx={{ my: 0 }} />
                        </ListItemButton>
                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary="Logout" sx={{ my: 0 }} />
                        </ListItemButton>
                    </List>
                </nav>
            </JumboDdPopover>


            {open && <ViewMET open={open} setOpen={setOpen} title={"Market Executive Details"}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ width: "30%" }}>
                        <TextFeild label={"Company Name"} value={metData?.company_details?.companyName || "N/A"} />
                        <TextFeild label={"GST No"} value={metData?.kyc?.gst?.gst_no || "N/A"} />
                        <TextFeild label={"On Boarding date"} value={formatDate(metData?.contact_person_details?.onboarding_date) || "N/A"} />
                        <TextFeild label={"First Name"} value={metData?.contact_person_details?.first_name || "N/A"} />
                        <TextFeild label={"Last Name"} value={metData?.contact_person_details?.last_name || "N/A"} />
                        <TextFeild label={"Primary Email ID"} value={metData?.contact_person_details?.primary_email_id || "N/A"} />
                        <TextFeild label={"Secondary Email ID"} value={metData?.contact_person_details?.secondary_email_id || "N/A"} />
                        <TextFeild label={"Primary Mobile No"} value={metData?.contact_person_details?.primary_mobile_no || "N/A"} />
                        <TextFeild label={"Secondary Mobile No"} value={metData?.contact_person_details?.primary_mobile_no || "N/A"} />
                        <TextFeild label={"Role"} value={metData?.contact_person_details?.role_assign || "N/A"} />
                        <TextFeild label={"Address"} value={`
                            ${metData?.address?.address} 
                            ${metData?.address?.area}
                            ${metData?.address?.location}
                            ${metData?.address?.district}
                            ${metData?.address?.taluka}
                            ${metData?.address?.city}
                            ${metData?.address?.state}
                            ${metData?.address?.pincode}`} />
                    </Box>
                    <Box sx={{ width: "30%" }}>
                        <TextFeild label={"PAN No"} value={metData?.kyc?.pan?.pan_no || "N/A"} />
                        <TextFeild label={"Aadhar No"} value={metData?.kyc?.aadhar?.aadhar_no || "N/A"} />
                        <Box>
                            <Typography sx={{ mt: 2, fontWeight: 500, fontSize: "17px", color: "black" }}>Insurance Details</Typography>
                            <TextFeild label={"Policy No"} value={metData?.insurance?.policy_company_name || "N/A"} />
                            <TextFeild label={"Company Name"} value={metData?.insurance?.policy_no || "N/A"} />
                            <TextFeild label={"Amount"} value={metData?.insurance?.policy_amount || "N/A"} />
                            <TextFeild label={"Renewal Date"} value={formatDate(metData?.insurance?.renewal_date) || "N/A"} />
                        </Box>
                        <Box>
                            <Typography sx={{ mt: 2, fontWeight: 500, fontSize: "17px", color: "black" }}>Bank Details</Typography>
                            <TextFeild label={"Bank Name"} value={metData?.kyc?.bank_details?.bank_name || "N/A"} />
                            <TextFeild label={"Account No"} value={metData?.kyc?.bank_details?.account_no || "N/A"} />
                            <TextFeild label={"IFSC Code"} value={metData?.kyc?.bank_details?.ifsc_code || "N/A"} />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography sx={{ fontSize: "23px", color: "black" }}>
                        Nominee Details
                    </Typography>
                    <Box>
                        <TableContainer component={Paper} sx={{ my: "2%" }}>
                            <Table sx={{ minWidth: 650 }} size="medium" >
                                <TableHead>
                                    <TableRow sx={{ bgcolor: "#7352C7" }}>
                                        {
                                            ["DOB", "Name", "Age", "PAN No", "Aadhar No", "Address",].map((head, index) => {
                                                return (
                                                    <TableCell align={"left"} key={index} sx={{
                                                        textTransform: "capitalize",
                                                        color: "white",
                                                        verticalAlign: "middle", minWidth: "200px", textAlign: "left"
                                                    }}>
                                                        {head}
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        metData?.nominee?.map((nomineeElem, index) => {
                                            return (
                                                <TableRow key={nomineeElem?._id}>
                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {formatDate(nomineeElem?.nominee_dob)}
                                                    </TableCell>
                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {nomineeElem?.nominee_name || "NA"}
                                                    </TableCell>
                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {nomineeElem?.nominee_age || "NA"}
                                                    </TableCell>
                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {nomineeElem?.kyc?.pan?.pan_no || "NA"}
                                                    </TableCell>

                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {nomineeElem?.kyc?.aadhar?.aadhar_no || "NA"}
                                                    </TableCell>

                                                    <TableCell align="left" sx={{
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                    }}>
                                                        {`
                                                            ${nomineeElem?.address?.address} 
                                                            ${nomineeElem?.address?.area}
                                                            ${nomineeElem?.address?.location}
                                                            ${nomineeElem?.address?.district}
                                                            ${nomineeElem?.address?.taluka}
                                                            ${nomineeElem?.address?.city}
                                                            ${nomineeElem?.address?.state}
                                                            ${nomineeElem?.address?.pincode}`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                            {/* <Pagination
                        count={marketExecutiveList?.allMarketExecutive?.data?.totalPages || 0}
                        page={page}
                        onChange={handleChangePage}
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            left: 0,
                            p: "1%",
                            backgroundColor: "white",
                            borderTop: "1px solid #ddd",
                        }}
                    /> */}
                        </TableContainer>
                    </Box>
                </Box>
            </ViewMET>}
        </ThemeProvider>
    );
};

export default AuthUserDropdown;
